export default function BlogCard({ blog, onDelete, onEdit }) {
  return (
    <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-4 flex items-center justify-between">
      <div>
        <h3 className="text-lg font-semibold">{blog.title}</h3>
        <p className="text-sm text-gray-500 mt-1">{blog.date}</p>
      </div>
      <div className="flex gap-2">
        <button
          onClick={() => onEdit(blog)}
          className="px-3 py-1 text-sm bg-blue-600 text-white rounded hover:bg-blue-700 cursor-pointer"
        >
          Edit
        </button>
        <button
          onClick={() => onDelete(blog.id)}
          className="px-3 py-1 text-sm bg-red-600 text-white rounded hover:bg-red-700 cursor-pointer"
        >
          Delete
        </button>
      </div>
    </div>
  );
}
